import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdSenderVerificationSetupRdnsCacheKeys: AllRouteEndpoints[] = [];
